import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {MmcMarketingDocumentsDialogComponent} from "@irb/irb-editors/editor-mmc-model/mmc-marketing-documents-dialog/mmc-marketing-documents-dialog.component";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";
import {CustomfilterComponent} from "@irb/irb-clients/portfolios/customfilter/customfilter.component";
import {IrbAgSetColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";
import {UpDownReorderCellComponent} from "@irb-common/components/grid/renderers/up-down-reorder.cell.component";
import {RequiredTextboxEditor} from "@irb-common/components/grid/editors/required-textbox-editor";


@Injectable({
    providedIn: "root"
})
export class MmcMarketingDocumentsGridLayoutService implements GridLayoutService<MmcMarketingDocumentsDialogComponent> {
    sizeFor: any;

    getFrameworkComponents(): any {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
            "irb-grid-up-down-reorder-cell": UpDownReorderCellComponent,
            "RequiredTextboxEditor":RequiredTextboxEditor
        };
    }

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "symbol": 60
        };
    }

    getColumnDefs(parent: any) {
        return [
             {
            headerName: "Reorder",
            resizable: false,
            minWidth: 80,
            maxWidth: 80,
            width: 80,
            pinned: "left",
            suppressColumnsToolPanel: true,
            lockPosition: true,
            sortable: false,
                 cellRenderer:UpDownReorderCellComponent,
            cellRendererParams : {
                downClick: parent.downArrowClick.bind(parent),
                upClick: parent.upArrowClick.bind(parent)
            },
            rowDrag: true,
            colId:'Reorder'
        },
            {
                headerName: "Link (opens in new window/tab)",
                field: "name",
                pinned: "left",
                lockVisible: true,
                lockPosition: true,
                editable: false,
                cellClass: 'nav-link-text',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {
                    link: (params: any) => {
                        return (params.value != null && params.value.length > 0);
                    },
                    onClick: parent.openMarketingDocument.bind(parent)
                },
                sortable: false,
                colId:'file_link'
            },
            {
                headerName: "Link name (required)",
                field: "title",
                pinned: "left",
                lockVisible: true,
                lockPosition: true,
                editable: true,
                cellEditor: 'RequiredTextboxEditor',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: 'TruncateTooltipCellComponent',
                //tooltipPosition: 'bottom',
                cellEditorParams: {
                    required: true,
                    autofocus: true,
                    width: '100%',
                    tooltiptext: 'Please enter a link name'
                },
                sortable: false,
                colId:'title'
            }, {
                headerName: 'Delete link',
                cellRenderer: 'DeleteCellComponent',
                cellRendererParams: {
                    message: "Delete this link?",
                    proceed: parent.delete.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                resizable: false,
                cellStyle: {'text-align': 'center'},
                minWidth: 120,
                maxWidth: 120,
                width: 120,
                lockPosition: true,
                sortable: false,
                colId:'deleteFileLink'
            },
        ];
    }

}
